import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  padding: 24px 0;

  @media ${p => p.theme.breakpoints.lg} {
    padding: 32px 0;
  }

  /* @media ${p => p.theme.breakpoints.xl} {
    padding: 48px;
  } */
`

export const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`

export const HeadingWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
  width: 100%;

  @media ${p => p.theme.breakpoints.lg} {
    margin-bottom: 32px;
  }

  /* @media ${p => p.theme.breakpoints.xl} {
    margin-bottom: 48px;
  } */
`

export const Heading = styled.h2`
  text-align: center;
`

export const Cards = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-inline-start: 0;
  list-style-type:none;
  margin:-15px;
`

export const CardWrapper = styled.li`
  min-height: 400px;
  padding: 15px;
  width: 100%;


  @media ${p => p.theme.breakpoints.sm} {
    width: 50%;
  }

  @media ${p => p.theme.breakpoints.md} {
    width: 33.3%;
  }

  // @media ${p => p.theme.breakpoints.lg} {
  //   width: 25%;
  // }

  // @media ${p => p.theme.breakpoints.xl} {
  //   width: 20%;
  // }
`

export const Card = styled.div`
  height: 100%;
  //box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 30px 4px rgba(0,0,0,0.10) !important;
`

export const Img = styled.div`
  background-image: ${p => `url(/a/${p.img}), linear-gradient(135deg, ${p.theme.colors.primary} 0%, #040025 100%)`};
  background-size: cover;
  background-position: center;
  background-blend-mode: screen;
  width: 100%;
  margin-bottom: 12px;
  // padding-top: 75%;
  height:210px;
`

export const TextWrapper = styled.div`
  padding: 10px;
`

export const CardHeading = styled.h4`
  margin-bottom: 6px;
`

export const Text = styled.p`
  font-size: 14px;
`

export const ButtonSection = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;

  @media ${p => p.theme.breakpoints.lg} {
    margin-top: 32px;
  }

  /* @media ${p => p.theme.breakpoints.xl} {
    margin-top: 48px;
  } */
`

export const ButtonWrapper = styled.div`
  padding: 2px;
  background-color: ${p => p.theme.colors.primary};
  // background: linear-gradient(90deg, #29B2C4 0%, #B2DE7F 100%);
  border-radius: 256px;
  transition: transform 70ms ease;

  &:active {
    transform: scale(0.95);
  }
`

export const Button = styled.button`
  padding: 10px 24px;
  background-color: #fff;
  border: none;
  border-radius: 256px;
  cursor: pointer;
  font-size: 16px;
  color: #333;

  &:focus {
    outline: none;
  }
`